var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headers"},_vm._l((_vm.$store.state.customData.jumpbtn),function(item,index){return _c('span',{key:index,on:{"click":function($event){return _vm.gotoPage(item.nav_url)}}},[_vm._v(_vm._s(item.title))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }